import React from 'react'
import styled from 'styled-components'
import Spinner from '../SmallSpinner'

const ListItemPlaceholder = ({ icon, title, description, clickable, onClick, pending }) => {
  return (
    <React.Fragment>
      <Wrapper className={['active', 'attention']} onClick={clickable ? onClick : undefined}>
        {pending ? <Spinner color={'secondary'} /> : <Icon src={icon} alt="" />}
        <Content>
          <Title>
            {title}
          </Title>
          <Subtitle>
            <Description>
              {description}
            </Description>
          </Subtitle>
        </Content>
      </Wrapper>
    </React.Fragment>
  )
}

const Wrapper = styled.div`
  box-shadow: rgb(219 219 219) 0px 2px 8px;
  border-radius: 5px;
  position: relative;
  background-color: ${({ theme }) => theme.primaryBackground};
  display: flex;
  align-items: center;
  padding: 0.8em 1em;
  margin: 0.3em;
  border: solid 2px ${({ theme: { primaryBackground } }) => primaryBackground};
  cursor: pointer;

  &.active {
    border-color: ${({ theme: { primary } }) => primary};
  }
  &.attention {
    box-shadow: rgb(180 180 200) 0px 2px 8px;
  }
  &.disabledInteraction {
    cursor: default;
  }
`

const Content = styled.div`
  flex-grow: 1;
  overflow: hidden;
  white-space: nowrap;
  width: 33%;
  padding-right: 0em;
`

const Icon = styled.img`
  margin-right: 1.5em;
  height: 2em;
  width: 2em;
  flex-shrink: 0;
`

const Title = styled.div`
  font-size: ${({ small, theme: { normalText, largeText } }) =>
    small ? normalText : largeText};
  ${({ title, theme: { secondary } }) => !title && 'color: ' + secondary}
  margin-bottom: 0.2em;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Subtitle = styled.div`
  display: flex;
  flex-direction: row;
`

const Description = styled.span`
  ${({ description, small, theme: { secondary, subtleText } }) =>
    !description ? 'color: ' + secondary : small && 'color: ' + subtleText}
  overflow: hidden;
  text-overflow: ellipsis;
`

export default ListItemPlaceholder
